<div #preview class="fileUploader__document">
  <button type="button" class="fileUploader__document__removeBtn" (click)="onFileRemove.emit()"></button>
</div>
